type BuildYear = { byg026Opførelsesår: number };

export async function getHouseNumberId(adresseid: string): Promise<string | null> {
	const addressUrl =
		'https://services.datafordeler.dk/DAR/DAR/3.0.0/rest/adresseTilHusnummer?' +
		new URLSearchParams({
			adresseid,
		}).toString();

	try {
		const response = await fetch(addressUrl);
		const husnummerId: string = await response.json();
		if (!response.ok) {
			return null;
		}
		return husnummerId;
	} catch {
		console.error('Error when fetching plot id');
		return null;
	}
}

export async function getBuildYears(husnummer: string): Promise<number[] | null> {
	const addressUrl =
		'https://services.datafordeler.dk/BBR/BBRPublic/1/rest/bygning?' +
		new URLSearchParams({
			username: 'VLYEPEWIKH',
			password: 'JCdW!fQMY24$',
			husnummer,
		}).toString();

	try {
		const response = await fetch(addressUrl);
		if (!response.ok) {
			return null;
		}
		const buildingsOnPlot: BuildYear[] = await response.json();
		const buildYears = buildingsOnPlot.filter(building => building.byg026Opførelsesår).map(building => building.byg026Opførelsesår);
		return buildYears;
	} catch {
		console.error('Error when fetching build years on a plot');
		return null;
	}
}

export function isRiskOfAsbestos(buildYears: number[]): boolean | null {
	const ASBESTOS_CUTOFF_YEAR = 1990;

	const hasBuildingsWithoutRisk = buildYears.some(year => year > ASBESTOS_CUTOFF_YEAR);
	const hasBuildingsWithRisk = buildYears.some(year => year < ASBESTOS_CUTOFF_YEAR);

	if (hasBuildingsWithoutRisk && hasBuildingsWithRisk) {
		return null;
	}
	if (hasBuildingsWithoutRisk) {
		return false;
	}
	if (hasBuildingsWithRisk) {
		return true;
	}
	return null;
}
